<script setup>

</script>

<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33325 10H11.6666" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.33325 6.66666H11.6666" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.6666 17.5V15C11.6666 14.558 11.491 14.1341 11.1784 13.8215C10.8659 13.5089 10.4419 13.3333 9.99992 13.3333C9.55789 13.3333 9.13397 13.5089 8.82141 13.8215C8.50885 14.1341 8.33325 14.558 8.33325 15V17.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.00008 8.33334H3.33341C2.89139 8.33334 2.46746 8.50894 2.1549 8.8215C1.84234 9.13406 1.66675 9.55798 1.66675 10V15.8333C1.66675 16.2754 1.84234 16.6993 2.1549 17.0119C2.46746 17.3244 2.89139 17.5 3.33341 17.5H16.6667C17.1088 17.5 17.5327 17.3244 17.8453 17.0119C18.1578 16.6993 18.3334 16.2754 18.3334 15.8333V7.50001C18.3334 7.05798 18.1578 6.63406 17.8453 6.3215C17.5327 6.00894 17.1088 5.83334 16.6667 5.83334H15.0001" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 17.5V4.16667C5 3.72464 5.17559 3.30072 5.48816 2.98816C5.80072 2.67559 6.22464 2.5 6.66667 2.5H13.3333C13.7754 2.5 14.1993 2.67559 14.5118 2.98816C14.8244 3.30072 15 3.72464 15 4.16667V17.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<style scoped>

</style>